import React from 'react';
import Card, { CardActions, CardContent, CardHeader } from 'material-ui/Card';
import Button from 'material-ui/Button';
import OLYWebPageComponent from '../OLYWebPageComponent';

export default class Noauth extends OLYWebPageComponent {
    constructor(props) {
        super(props);

        this.pageName = 'UnAuthorized';
        this.pageTitle = 'No Autorizado';
        this.pageReference = '';

        this.state = {
        };
    }

    render() {
        return (
            <div className={'mainbody'}>
                <div className={'loginbox'} style={{marginTop:'10px'}}>
                    <Card>
                        <CardHeader
                            title="No Autorizado"
                            subheader="Error al acceder al recurso solicitado"
                        />
                        <CardContent>
              Usted no esta autorizado a acceder a este recurso o no se encuentra disponible.
                        </CardContent>
                        <CardActions>
                            <Button href="/"
                                color="primary">
                    Inicio
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Noauth/Noauth.js